import {html} from 'lit-html';

import TemplateRegistry from '../template/template-registry';
import Translate from '../translate';
import {
    inputColorSupported, textEditorProperty
} from '../template/template-util.js';

TemplateRegistry.templates['text_editor'] = (option, config, onChange) => html`
    <div class="cl-po--text-editor">

        ${TemplateRegistry.templates['hidden']({
            // hidden option to save all the editor settings
            id: option.id + '_editor',
            name: '_' + option.name + '_editor',
            params: {},
            value: textEditorProperty(option) // generate current editor settings
        }, config)}
        
        ${option._layer.params.editor.font ? html`
        <div class="cl-po--editor-group cl-po--font-family">
            ${TemplateRegistry.templates['font']({
                // custom 'fake' option to save the selected font family
                id: option.id + '_font',
                name: option.name + '_font',
                params: {
                    // INFO: overwrite name to not wrap with propertes[] (hidden _editor property contains all settings)
                    name: option.name + '_font'
                },
                // pre select
                value: option._editor.fontFamily
            }, config, (fontOption) => {
                // map option value to editor
                option._editor.fontFamily = fontOption.value;
                // trigger render of preview
                onChange(option);
            })}
        </div>`: null }
        ${option._layer.params.editor.style ? html` 
        <div class="cl-po--editor-group cl-po--font-style">
            <div @click=${(e) => {option._editor.fontWeight = (option._editor.fontWeight === 'bold' ? 'normal' : 'bold'); onChange(option) }} class="cl-po--swatch cl-po--swatch-button ${option._editor.fontWeight === 'bold' ? 'selected': ''}" data-tippy-content="${Translate.get('product.options.text.style.bold')}" data-tippy-placement="bottom">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M8 11h4.5a2.5 2.5 0 1 0 0-5H8v5zm10 4.5a4.5 4.5 0 0 1-4.5 4.5H6V4h6.5a4.5 4.5 0 0 1 3.256 7.606A4.498 4.498 0 0 1 18 15.5zM8 13v5h5.5a2.5 2.5 0 1 0 0-5H8z" fill="var(--text-editor-color)"/></svg>
            </div>
            <div @click=${(e) => {option._editor.fontStyle = (option._editor.fontStyle === 'italic' ? 'normal' : 'italic'); onChange(option) }} class="cl-po--swatch cl-po--swatch-button ${option._editor.fontStyle === 'italic' ? 'selected': ''}" data-tippy-content="${Translate.get('product.options.text.style.italic')}" data-tippy-placement="bottom">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15z" fill="var(--text-editor-color)"/></svg>
            </div>
        </div>`: null }
        ${option._layer.params.editor.align ? html` 
        <div class="cl-po--editor-group cl-po--text-align">
            <div @click=${(e) => {option._editor.textAlign = 'left'; onChange(option) }} class="cl-po--swatch cl-po--swatch-button ${option._editor.textAlign === 'left' ? 'selected': ''}" data-tippy-content="${Translate.get('product.options.text.align.left')}" data-tippy-placement="bottom">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M3 4h18v2H3V4zm0 15h14v2H3v-2zm0-5h18v2H3v-2zm0-5h14v2H3V9z" fill="var(--text-editor-color)"/></svg>
            </div>
            <div @click=${(e) => {option._editor.textAlign = 'center'; onChange(option) }} class="cl-po--swatch cl-po--swatch-button ${option._editor.textAlign === 'center' ? 'selected': ''}" data-tippy-content="${Translate.get('product.options.text.align.center')}" data-tippy-placement="bottom">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M3 4h18v2H3V4zm2 15h14v2H5v-2zm-2-5h18v2H3v-2zm2-5h14v2H5V9z" fill="var(--text-editor-color)"/></svg>
            </div>
            <div @click=${(e) => {option._editor.textAlign = 'right'; onChange(option) }} class="cl-po--swatch cl-po--swatch-button ${option._editor.textAlign === 'right' ? 'selected': ''}" data-tippy-content="${Translate.get('product.options.text.align.right')}" data-tippy-placement="bottom">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M3 4h18v2H3V4zm4 15h14v2H7v-2zm-4-5h18v2H3v-2zm4-5h14v2H7V9z" fill="var(--text-editor-color)"/></svg>
            </div>
        </div>`: null }
        ${option._layer.params.editor.size ? html` 
        <div class="cl-po--editor-group cl-po--font-size">
            <div @click=${(e) => {option._editor.fontSize = Math.max((option._layer.params.fontSizeMin || 1), option._editor.fontSize - (option._layer.params.fontSizeStep || 1)); onChange(option) }} class="cl-po--swatch cl-po--swatch-button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M5 11h14v2H5z" fill="var(--text-editor-color)"/></svg>
            </div>
            <div class="cl-po--swatch cl-po--swatch-button icon" data-tippy-content="${Translate.get('product.options.text.fontSize')}" data-tippy-placement="bottom">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M11.246 15H4.754l-2 5H.6L7 4h2l6.4 16h-2.154l-2-5zm-.8-2L8 6.885 5.554 13h4.892zM21 12.535V12h2v8h-2v-.535a4 4 0 1 1 0-6.93zM19 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" fill="var(--text-editor-color)"/></svg>
            </div>
            <div @click=${(e) => {option._editor.fontSize = Math.min((option._layer.params.fontSizeMax || 100000), option._editor.fontSize + (option._layer.params.fontSizeStep || 1)); onChange(option) }} class="cl-po--swatch cl-po--swatch-button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" fill="var(--text-editor-color)"/></svg>
            </div>
        </div>`: null }
         ${option._layer.params.editor.color ? html` 
        <div class="cl-po--editor-group cl-po--font-color">
            ${TemplateRegistry.templates['color']({
                // custom 'fake' option to save the selected font color
                id: option.id + '_color',
                name: option.name + '_color',
                params: {
                    // INFO: overwrite name to not wrap with propertes[] (hidden _editor property contains all settings)
                    name: option.name + '_color'
                },
                // pre select
                value: option._editor.color || '#000000'
            }, config, (colorOption) => {
                // map option value to editor
                option._editor.color = colorOption.value;
                // trigger render of preview
                onChange(option);
            })}
            ${inputColorSupported() ? // INFO: only if the color element is supported > show the color input (otherwise the color element already shows the text input)
                    html`
            <div class="cl-po--font-color-input">
            ${TemplateRegistry.templates['color_input']({
                        // custom 'fake' option to save the selected font color
                        id: option.id + '_color',
                        name: option.name + '_color',
                        params: {
                            // INFO: overwrite name to not wrap with propertes[] (hidden _editor property contains all settings)
                            name: option.name + '_color'
                        },
                        // pre select
                        value: option._editor.color || '#000000'
                    }, config, (colorOption) => {    // INFO: because we create a new "fake" option object on every render the color value is synched automatically!
                        // map option value to editor
                        option._editor.color = colorOption.value;
                        // trigger render of preview
                        onChange(option);
                    })}
              </div>`: null
            }
        </div>`: null }
        
    </div>
    
    ${option._layer ?  html`${TemplateRegistry.templates['layer_editor'](option, config, onChange)}`: null}
`;